import React from "react";

import { Fade } from "react-awesome-reveal";

import Button from "../elements/Button";

export default function Discuss() {
  return (
    <Fade direction="up" triggerOnce>
      <section className="container mx-auto flex justify-center px-4">
        <div className="relative mt-10 flex w-full flex-col overflow-hidden rounded-3xl bg-gradient-to-br from-maroon-800 to-maroon-950 px-6 py-14 text-gray-100 shadow-2xl sm:px-12 sm:py-16 xl:w-10/12 xl:px-16">
          <div
            className="pointer-events-none absolute -right-16 -top-16 h-64 w-64 rounded-full bg-gold-500/10"
            aria-hidden="true"
          />
          <div className="flex flex-col items-start gap-6 sm:flex-row sm:items-center sm:justify-between">
            <h2 className="font-display max-w-xl text-3xl leading-tight sm:text-4xl lg:text-5xl">
              Partner with Us for Exceptional Flavor Solutions
            </h2>
            <Fade direction="up" triggerOnce delay={300}>
              <Button
                href="/contact-us"
                type="link"
                className="flex shrink-0 items-center justify-center rounded-full bg-gold-400 px-8 py-4 text-lg font-semibold text-maroon-900 shadow-xl transition-transform duration-300 hover:scale-105 hover:bg-gold-300"
              >
                Contact Us
              </Button>
            </Fade>
          </div>
          <Fade delay={200} triggerOnce>
            <p className="mt-5 max-w-2xl text-lg font-light text-maroon-100 sm:text-xl">
              Reach out to explore our custom and bulk sauce options for your business.
            </p>
          </Fade>
        </div>
      </section>
    </Fade>
  );
}
